"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_shopping__trolley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "shopping-trolley-hi"), /*#__PURE__*/React.createElement("g", {
    id: "1bb5caab-e3ea-403a-8da7-5c30e949396b",
    "data-name": "shopping-trolley-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5cc5b0d5-f856-4850-8b01-c9f42cce65ef",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "464bd0d2-cff6-4378-b359-2baa331d2803",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6d27c869-1817-4a74-8446-5ec66acd7d9f",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3af873e-86e2-4de6-978b-5404b035142d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12e3ccae-b88b-4ff2-acde-c440efd5454b",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8e1cd27a-f014-4491-92e4-b1ca60ae8324",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "95183b5a-6c4c-4c40-8fb3-8f98b089d539",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4dd3a489-0ae1-478c-a96e-ee6f50cbe222",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3586c258-7a1d-430a-a08f-822b299f101d",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "32a1e27d-b49e-4f65-9ac7-8d65c2b8c219",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f05099cf-f4e6-4354-9844-4c0552b43e46",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c71437a-afda-4846-a5d1-09dab722d90e",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "963c73e3-2a80-4dc8-9d4c-e7aaa059ac73",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "98f3d4b4-b22f-4abe-bdff-6b7c04a6d172",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "980e6a1b-fe8a-450f-9250-bfc87152811b",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "6c9cb72b-adad-4027-bbb0-b55421f3f09f",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,111.92H68l-20-72H164.47a8,8,0,0,1,7.71,10.14l-15.56,56A8,8,0,0,1,148.92,111.92Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.95,
    y: 48.28,
    width: 8,
    height: 56,
    rx: 4,
    ry: 4,
    transform: "matrix(0.99, -0.13, 0.13, 0.99, -9.14, 12.38)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.07,
    y: 48.81,
    width: 8,
    height: 56,
    rx: 4,
    ry: 4,
    transform: "translate(-16.85 20.9) rotate(-14.29)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.19,
    y: 72.28,
    width: 56,
    height: 8,
    rx: 4,
    ry: 4,
    transform: "matrix(0.13, -0.99, 0.99, 0.13, 40.42, 198.49)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.07,
    y: 72.81,
    width: 56,
    height: 8,
    rx: 4,
    ry: 4,
    transform: "translate(39.86 204.97) rotate(-75.71)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.75,
    y: 47.81,
    width: 8,
    height: 56,
    rx: 4,
    ry: 4,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.18,48.06l-15.56,56a8,8,0,0,1-7.71,5.86H68l-19.44-70H48l20,72h80.92a8,8,0,0,0,7.71-5.86l15.56-56a8,8,0,0,0,.22-3.14A8.12,8.12,0,0,1,172.18,48.06Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,99.58,95.88,52a4,4,0,1,0-7.94,1l.08.63a4,4,0,0,1,7.86.36l6,47A3.93,3.93,0,0,0,102,99.58Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,99.08,74,52.56a4,4,0,0,0-7.75,2v.06a4,4,0,0,1,7.74,0L85.86,101A3.94,3.94,0,0,0,85.87,99.08Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,48.5A4,4,0,0,0,132.26,52l-6.07,47.61a3.93,3.93,0,0,0,.08,1.37l6-47a4,4,0,0,1,7.86-.36l.08-.63A4,4,0,0,0,136.73,48.5Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,51.67a4,4,0,0,1,2.88,2.92v-.06a4,4,0,0,0-7.75-2L142.27,99.08a3.94,3.94,0,0,0,0,1.94l11.83-46.46A4,4,0,0,1,159,51.67Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,48.06a4,4,0,0,0-4,4v2a4,4,0,1,1,8,0v-2A4,4,0,0,0,114,48.06Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,127.92H77.55l-28-98.11A8,8,0,0,0,41.85,24H20.11A4.12,4.12,0,0,0,16,27.61a4,4,0,0,0,4,4.39H41.85l27.72,97.08L65,146l7.69,2.22L76,135.92h72.07a4,4,0,0,0,0-8Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,127.92H77.55l-28-98.11A8,8,0,0,0,41.85,24H20.11A4.12,4.12,0,0,0,16,27.61a4,4,0,0,0,4,4.39H41.85l27.72,97.08L65,146l7.69,2.22L76,135.92h72.07a4,4,0,0,0,0-8Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.11,24A4.12,4.12,0,0,0,16,27.61a4,4,0,0,0,4,4.39H41.67V24Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,30H19.94a4,4,0,0,1-3.86-3,3.77,3.77,0,0,0-.12.63,4,4,0,0,0,4,4.39H41.85l27.44,96.11.28-1Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,133.92H76l-3.3,12.29-7.19-2.08L65,146l7.69,2.22L76,135.92h72.07a4,4,0,0,0,3.86-5A4,4,0,0,1,148.08,133.92Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08,27a3.77,3.77,0,0,0-.12.63,4,4,0,0,0,4,4.39H41.67V30H19.94A4,4,0,0,1,16.08,27Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.8,
    cy: 143.79,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.97,
    cy: 143.79,
    r: 8,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,150a8,8,0,0,1-7.93-7A8,8,0,1,0,148,143,8,8,0,0,1,140.05,150Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,150a8,8,0,0,1-7.93-7,8,8,0,1,0,15.86,0A8,8,0,0,1,68.22,150Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }))))))))))))))))));
}

var _default = ic_shopping__trolley;
exports.default = _default;